<nav compact tuiSubheader [style.position]="'sticky'" class="bg-white">
    <tui-breadcrumbs [itemsLimit]="10">
        <ng-container *ngFor="let item of breadcrumbs; let last = last">
            <ng-container *ngIf="last; else notLast">
                <strong *tuiItem tuiFade>
                    {{ item.label }}
                </strong>
            </ng-container>
            <ng-template #notLast>
                <button *tuiItem tuiLink type="button" (click)="navigate(item.link)" [disabled]="!item.link">
                    {{ item.label }}
                </button>
            </ng-template>
        </ng-container>
    </tui-breadcrumbs>
</nav>

<tui-loader [overlay]="true" [showLoader]="isLoading && !newNurse" class="w-full block min-h-[400px]">

    <section class="w-full">
        <p class="text-4xl font-normal mt-[0.9rem]">{{newNurse? 'Register New Nurse':'Update Nurse'}}</p>
        <form [formGroup]="nurseForm" (ngSubmit)="saveUser()">
            <div class="flex">
                <div>
                    <p class="text-base font-medium text-[#3E4A58] my-0">Personal Information</p>
                    <p class="text-sm font-normal text-[#949494D9] my-0 w-[225px]">Enter personal Information of the
                        nurse
                    </p>
                </div>
                <div class="w-full xl:w-1/3 2xl:w-1/3 pl-[6rem]">
                    <label tuiLabel>
                        <tui-input formControlName="name">Nurse Name <input tuiTextfieldLegacy
                                type="text" /></tui-input>
                        <tui-error formControlName="name" class="mb-3" [error]="[] | tuiFieldError | async" />
                    </label>

                    <label tuiLabel *ngIf="!showPermanentFields">
                        <div class="casual-id-field">
                            <span class="casual-id-prefix" aria-hidden="true">{{ casualIdPrefix }}</span>
                            <tui-input formControlName="casualIdDigits" class="casual-id-digits">
                                Casual ID
                                <input tuiTextfieldLegacy type="text" inputmode="numeric" maxlength="5"
                                    placeholder="00001" />
                            </tui-input>
                        </div>
                        <p *ngIf="newNurse && suggestedCasualId"
                            class="text-xs text-[#191C30E5] ml-4 mt-1 mb-3 leading-4">
                            Last Casual ID: <b>{{ lastCasualId || "—" }}</b>
                            <span class="mx-1">•</span>
                            Suggested: <b>{{ suggestedCasualId }}</b>
                            <button type="button"
                                class="ml-2 text-xs text-[#526ED3] underline decoration-dotted underline-offset-4 cursor-pointer bg-transparent border-none p-0"
                                (click)="useSuggestedCasualId()">
                                Use suggested
                            </button>
                        </p>
                        <p class="text-xs text-[#949494] ml-4 mt-1 mb-2">
                            Auto-generated. Format: CID- plus exactly 5 digits. Only the number is editable.
                        </p>
                        <tui-error formControlName="casualIdDigits" class="mb-3" [error]="[] | tuiFieldError | async" />
                    </label>

                    <ng-container *ngIf="showPermanentFields">
                        <label tuiLabel>
                            <tui-input formControlName="epfNumber">EPF Number <input tuiTextfieldLegacy
                                    type="text" /></tui-input>
                            <tui-error formControlName="epfNumber" class="mb-3"
                                [error]="[] | tuiFieldError | async" />
                        </label>
                        <label tuiLabel>
                            <tui-input-date formControlName="appointmentDate">Appointment Date <input
                                    tuiTextfieldLegacy /></tui-input-date>
                            <p
                                *ngIf="!appointmentDateLocked"
                                class="text-xs text-[#64748B] ml-4 mt-1 mb-2 leading-4"
                            >
                                Appointment Date can be set only once. After you save, this field is locked because it is used to calculate annual leave. If you do not have the exact date yet, leave it empty and add the correct date later.
                            </p>
                            <p
                                *ngIf="appointmentDateLocked"
                                class="text-xs text-[#64748B] ml-4 mt-1 mb-2 leading-4"
                            >
                                Appointment Date is locked. It cannot be changed because it determines annual leave entitlement.
                            </p>
                            <tui-error formControlName="appointmentDate" class="mb-3"
                                [error]="[] | tuiFieldError | async" />
                        </label>
                    </ng-container>

                    <!-- <label tuiLabel>
                    <tui-input formControlName="refNo" >Employee Number <input tuiTextfieldLegacy
                            type="text" /></tui-input>
                    <tui-error formControlName="refNo" class="mb-3" [error]="[] | tuiFieldError | async" />
                </label> -->

                    <label tuiLabel>
                        <tui-input-date formControlName="registrationDate" [max]="maxDate">Actual Join Date <input
                                tuiTextfieldLegacy /></tui-input-date>
                        <tui-error formControlName="registrationDate" class="mb-3"
                            [error]="[] | tuiFieldError | async" />
                    </label>

                    <label tuiLabel>
                        <tui-input-date formControlName="dateOfBirth">Date of birth<input
                                tuiTextfieldLegacy /></tui-input-date>
                        <app-recommended-hint [control]="nurseForm.get('dateOfBirth')"
                            message="Recommended. You can save without it and update later." />
                        <tui-error formControlName="dateOfBirth" class="mb-3" [error]="[] | tuiFieldError | async" />
                    </label>

                    <label tuiLabel>
                        <tui-input formControlName="age">Age <input tuiTextfieldLegacy type="text" /></tui-input>
                        <tui-error formControlName="age" class="mb-3" [error]="[] | tuiFieldError | async" />
                    </label>

                    <!-- Profile Picture -->
                    <div *ngIf="!imageEditable">
                        <p class="text-sm font-normal text-[#949494D9]">Photograph of the Nurse</p>
                        <label tuiInputFiles class="mb-3">
                            <input #validator="tuiInputFilesValidator" accept="image/*" tuiInputFiles
                                [formControl]="control" [multiple]="true" (reject)="onReject($event)" placeholder=""
                                title="Profile Picture Input" />
                        </label>
                        <p class="text-red-600 py-0 my-0" *ngIf="nurseForm.get('profilePic')?.touched">
                            {{ getProfilePicError() }}
                        </p>

                        <tui-files class="tui-space_top-1 mb-3">
                            <tui-file *ngFor="let file of accepted$ | async" [file]="file" (remove)="onRemove(file)" />

                            <tui-file *ngFor="let file of rejected" state="error"
                                [file]="(file | tuiFileRejected: validator | async) || file"
                                (remove)="onRemove(file)" />
                        </tui-files>
                    </div>
                    <div *ngIf="imagePreview" class="mb-3 flex items-center space-x-3">
                        <div>
                            <p class="text-sm font-normal text-[#949494D9] mt-0 pt-0">Profile Picture Preview</p>
                            <img [src]="imagePreview" alt="Profile Picture Preview"
                                class="w-16 h-16 object-cover rounded-full border" />
                        </div>
                        <div *ngIf="!newNurse">
                            <button tuiButton type="button" size="m" appearance="outline" (click)="editImage()"
                                class="mt-5">
                                Edit
                            </button>
                        </div>
                    </div>

                    <tui-error [error]="['maxLength'] | tuiFieldError | async" [formControl]="control" />
                    <label tuiLabel>
                        <tui-input formControlName="email">Email <input tuiTextfieldLegacy type="email" /></tui-input>
                        <tui-error formControlName="email" class="mb-3" [error]="[] | tuiFieldError | async" />
                    </label>
                    <label tuiLabel>
                        <tui-input formControlName="contactNo">Contact Number (Whatsapp)<input tuiTextfieldLegacy
                                type="text" /></tui-input>
                        <tui-error formControlName="contactNo" [error]="[] | tuiFieldError | async" />
                    </label>

                    <div class="w-full ">
                        <label tuiLabel class="mt-3">
                            <tui-textarea formControlName="address" [tuiTextfieldLabelOutside]="true"
                                placeholder="Enter Notes" title="Textarea Input">Address</tui-textarea>
                            <tui-error formControlName="address" [error]="[] | tuiFieldError | async" />
                        </label>
                    </div>

                </div>

            </div>
                <div class="flex mt-5">
                    <div>
                        <p class="text-base font-medium text-[#3E4A58] my-0 w-[155px]">Guardian Details</p>
                        <p class="text-sm font-normal text-[#949494D9] my-0 w-[155px]">Enter the guardian details</p>
                    </div>
                    <div class="pl-[166px] w-full xl:w-1/3 2xl:w-1/3">
                        <label tuiLabel>
                            <tui-input formControlName="gurdianName">Name <input tuiTextfieldLegacy
                                    type="text" /></tui-input>
                            <tui-error formControlName="gurdianName" class="mb-3"
                                [error]="[] | tuiFieldError | async" />
                        </label>

                        <label tuiLabel>
                            <tui-input formControlName="gurdianContact">Contact Number <input tuiTextfieldLegacy
                                    type="text" /></tui-input>
                            <tui-error formControlName="gurdianContact" [error]="[] | tuiFieldError | async" />
                        </label>
                    </div>

                </div>
                <div class="flex mt-5">
                    <div>
                        <p class="text-base font-medium text-[#3E4A58] my-0 w-[125px]"></p>
                        <p class="text-sm font-normal text-[#949494D9] my-0 w-[125px]"></p>
                    </div>
                    <div class="pl-[190px] w-full xl:w-1/3 2xl:w-1/3">

                        <div class="flex items-center mt-5 space-x-4">
                            <input tuiSwitch type="checkbox" formControlName="active" placeholder=""
                                title="Switch Input" class="mt-5" />

                            <div>
                                <p class="text-sm font-normal text-[#3E4A58] my-0">Nurse Status</p>
                                <p class="text-xs font-normal text-[#A4A4A4] my-0">Not Active means user will not be
                                    able to
                                    access the system.</p>

                            </div>
                        </div>
                    </div>

                </div>
                <div class="flex">
                    <div class="mt-5">
                        <p class="text-base font-medium text-[#3E4A58] my-0">Notes</p>
                        <p class="text-sm font-normal text-[#949494D9] my-0">(Optional)</p>
                    </div>
                    <div class="pl-[255px]">
                        <div class="md:w-[350px] lg:w-[610px] xl:w-[420px] 2xl:w-[600px]">
                            <label tuiLabel class="mt-5">
                                <tui-textarea formControlName="notes" [tuiTextfieldLabelOutside]="true"
                                    placeholder="Enter Notes" title="Textarea Input">Start Typing...</tui-textarea>
                            </label>
                        </div>
                        <div class="mt-5 space-x-5 flex justify-end">
                            <!-- Cancel Button -->
                            <button [routerLink]="['/admin/nurse']" appearance="outline" tuiButton type="button">
                                Cancel
                            </button>

                            <!-- Save/Update Button -->
                            <button appearance="primary" tuiButton type="submit" class="w-[200px]"
                                [disabled]="isLoading"
                                [appDisableUnlessPermission]="newNurse ? 'NURSE_CREATE' : 'NURSE_UPDATE'">
                                <!-- State: Not Loading -->
                                <ng-container *ngIf="!isLoading">
                                    {{ newNurse ? 'Save New Nurse' : 'Update Nurse' }}
                                </ng-container>

                                <!-- State: Loading -->
                                <ng-container *ngIf="isLoading">
                                    {{ newNurse ? 'Saving...' : 'Updating...' }}
                                </ng-container>
                            </button>
                        </div>
                    </div>

                </div>


        </form>
    </section>

</tui-loader>

<ng-template
    [tuiDialogOptions]="{ label: 'Confirm Appointment Date', size: 's' }"
    [(tuiDialog)]="confirmAppointmentDialogOpen"
>
    <p class="text-sm mb-3">
        You are about to set
        <strong>{{ pendingAppointmentDateLabel }}</strong>
        as this nurse’s Appointment Date.
    </p>
    <p class="text-sm mb-3">
        This can be done only once. After saving, the date cannot be changed because it determines annual leave entitlement. Editing it later would cause incorrect leave balances.
    </p>
    <p class="text-sm mb-4">
        Please confirm this date is correct before continuing.
    </p>
    <div class="flex justify-end gap-2 flex-wrap">
        <button
            tuiButton
            type="button"
            size="s"
            appearance="secondary"
            (click)="onAppointmentDateCancel()"
        >
            Go back
        </button>
        <button
            tuiButton
            type="button"
            size="s"
            appearance="primary"
            (click)="onAppointmentDateConfirm()"
        >
            Confirm &amp; save
        </button>
    </div>
</ng-template>